// Cal Avatar Configuration
export interface CalAvatar {
  id: string;
  name: string;
  path: string;
}

export const calAvatars: CalAvatar[] = [
  {
    id: 'cal0',
    name: 'CAL 0',
    path: '/CAL0.png'
  },
  {
    id: 'cal1',
    name: 'CAL 1',
    path: '/CAL1.png'
  },
  {
    id: 'cal2',
    name: 'CAL 2',
    path: '/CAL2.png'
  },
  {
    id: 'cal3',
    name: 'CAL 3',
    path: '/CAL3.png'
  },
  {
    id: 'cal4',
    name: 'CAL 4',
    path: '/CAL4.png'
  },
  {
    id: 'cal5',
    name: 'CAL 5',
    path: '/CAL5.png'
  },
  {
    id: 'cal6',
    name: 'CAL 6',
    path: '/CAL6.png'
  },
  {
    id: 'cal7',
    name: 'CAL 7',
    path: '/CAL7.png'
  },
  {
    id: 'cal8',
    name: 'CAL 8',
    path: '/CAL8.png'
  }
];

export const defaultCalAvatar = 'cal4';

export function getCalAvatar(avatarId?: string): CalAvatar {
  const id = avatarId || localStorage.getItem('selectedCalAvatar') || defaultCalAvatar;
  return calAvatars.find(avatar => avatar.id === id) || calAvatars[4]; // Return CAL4 as fallback
}

export function saveCalAvatarPreference(avatarId: string): void {
  localStorage.setItem('selectedCalAvatar', avatarId);
}